import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

const HelpSidebar = ({ modules, role, locale, activeModuleId, onNavigate }) => {
  const visible = (modules || [])
    .filter((m) => Array.isArray(m.roles) && m.roles.includes(role || 'client'))
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <Nav className="flex-column help-sidebar-nav" data-testid="help-sidebar">
      {visible.map((m) => {
        const title = m.titles?.[locale] || m.titles?.es || m.id;
        const iconClass = m.icon || 'bi-file-text';
        const isActive = m.id === activeModuleId;
        return (
          <Nav.Link
            key={m.id}
            as={NavLink}
            to={`/ayuda/${m.id}`}
            className={`help-sidebar-link${isActive ? ' active' : ''}`}
            onClick={onNavigate}
            data-module-id={m.id}
          >
            <i className={`bi ${iconClass} me-2`} aria-hidden="true"></i>
            <span>{title}</span>
          </Nav.Link>
        );
      })}
    </Nav>
  );
};

export default HelpSidebar;
